// extracted by mini-css-extract-plugin
export default {"wrapper":"settings_wrapper__FyIeM","card_flex":"settings_card_flex__siuA-"};